import React from 'react';
import {Navbar, Typography} from "@material-tailwind/react";
import {Cog8ToothIcon} from "@heroicons/react/20/solid";

const Maintenance = () => {
    return (
        <section className="flex flex-col gap-4 w-full px-2 md:px-4 lg:px-10 py-4 md:py-8 sm:py-2">
            <Navbar className="mx-auto max-w-screen-xl px-2 py-2 lg:px-6 lg:py-4" shadow={false}>
                <div className="flex items-center justify-between text-blue-gray-900">
                    <img
                        src="https://ojinagagob.mx/wp-content/uploads/2024/09/Ojinaga.png"
                        className="w-80 mx-auto"
                    />
                </div>
            </Navbar>
            <div className="w-full mt-24">
                <div className="text-center">
                    <Cog8ToothIcon className="h-20 w-20 mx-auto hover:animate-spin animate-spin-slow" />
                    <Typography variant="h1" className="font-bold mb-4">Mantenimiento</Typography>
                    <Typography variant="paragraph" color="blue-gray" className="w-3/4 mx-auto text-lg font-normal">
                        Nuestro sitio está en mantenimiento para mejorar tu experiencia.
                    </Typography>
                    <Typography variant="paragraph" color="blue-gray" className="w-3/4 mx-auto text-lg font-normal">
                        Estaremos de vuelta pronto. Gracias por tu paciencia.
                    </Typography>
                </div>
            </div>
        </section>
    )
};

export default Maintenance;
